import { useState } from "react"
import { TintedButton } from "@shared/designSystem/Button"
import { CardContainer, VerticalMainContainer, VerticalContainer } from "@shared/designSystem/Containers"
import { H1Title, H2Title } from "@shared/designSystem/Titles"
import { Text } from "@shared/designSystem/Texts"
import UserCard from "@shared/designSystem/UserCard"
import { FullScreenModal } from "@shared/designSystem/messages/FullScreenModal"
import designSystemStyles from "@shared/styles/designSystemStyles"

const FullScreenModalShowcaseScreen = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [isFullscreenOpen, setIsFullscreenOpen] = useState(false)

    return (
        <VerticalMainContainer>
            <H1Title text="FullScreenModal Showcase" />
            <CardContainer>
                <VerticalContainer gap={designSystemStyles.gapSm} alignment="left">
                    <H2Title text="Full screen modal" />
                    <Text text="Opens a modal that occupies the entire screen, with a header title and close button. Press Escape or the close button to dismiss it." />
                    <TintedButton
                        text="Open full screen modal"
                        onClick={() => setIsOpen(true)}
                    />
                </VerticalContainer>
            </CardContainer>

            <CardContainer>
                <VerticalContainer gap={designSystemStyles.gapSm} alignment="left">
                    <H2Title text="Fullscreen layout" />
                    <Text text="Occupies the whole screen edge to edge, with no rounded corners. Escape does not dismiss it; only the close button does." />
                    <TintedButton
                        text="Open fullscreen layout modal"
                        onClick={() => setIsFullscreenOpen(true)}
                    />
                </VerticalContainer>
            </CardContainer>

            <FullScreenModal
                isOpen={isOpen}
                title="Full screen modal"
                onClose={() => setIsOpen(false)}
            >
                <VerticalContainer gap={designSystemStyles.gapMd} alignment="left">
                    <Text text="This modal occupies the entire screen." />
                    <Text text="The title and close button live in the header at the top. Press Escape or the close button to dismiss it." />
                    <UserCard name="John Doe" />
                </VerticalContainer>
            </FullScreenModal>

            <FullScreenModal
                isOpen={isFullscreenOpen}
                title="Fullscreen layout modal"
                layout="fullscreen"
                onClose={() => setIsFullscreenOpen(false)}
            >
                <VerticalContainer gap={designSystemStyles.gapMd} alignment="left">
                    <Text text="This layout covers the whole screen with no rounded corners." />
                    <Text text="Escape does not dismiss it; use the close button in the header." />
                </VerticalContainer>
            </FullScreenModal>
        </VerticalMainContainer>
    )
}

export default FullScreenModalShowcaseScreen
